export const languages = {
  en_US: 'en_US',
  es_ES: 'es_ES',
  pt_BR: 'pt_BR',
};
